import React from 'react';
import TransactionPage from '../pages/admin/TransactionPage';
import AdminHomePage from '../pages/admin/AdminHomePage';
import NewsPage from '../pages/admin/NewsPage';
import CreateCodeMoney from '../pages/admin/CreateCodeMoney';
import SettingPage from '../pages/admin/SettingPage';
import FeeTransactionPage from "../pages/admin/FeeTransactionPage";
import PackagePage from "../pages/admin/PackagePage";
import IPSettingPage from "../pages/admin/IPSettingPage";
import AgentManagePage from "../pages/admin/AgentManagePage";
import AgentDepositPage from "../pages/admin/AgentDepositPage";

const admins = [
{ path: '/admin', element: <AdminHomePage /> },
{ path: '/admin/transactions', element: <TransactionPage /> },
{ path: '/admin/create-code-money', element: <CreateCodeMoney /> },
{ path: '/admin/setting', element: <SettingPage /> },
{ path: '/admin/news', element: <NewsPage /> },
{ path: '/admin/fee', element: <FeeTransactionPage /> },
{ path: '/admin/package', element: <PackagePage /> },
{ path: '/admin/ip-setting', element: <IPSettingPage /> },
{ path: '/admin/agents', element: <AgentManagePage /> },
{ path: '/admin/agent-deposit', element: <AgentDepositPage /> },
];

export default admins;
